import React from "react";
import { ContainerReviewImport } from "./styles";
import { Col, Divider, Icon, Row, Table } from "antd";
import { useImportStatementFormContext } from "../context";
import moment from "moment";
import { numberMask } from "../../../../../../../../../services/helpersMethodsService";
import { useSelector } from "react-redux";
import ButtonStandard from "../../../../../../../../../components/utils/button";
import { useCallback } from "react";

const TYPES = [
  "DEBIT",
  "CREDIT",
  "XFER",
  "CHECK",
  "PAYMENT",
  "CASH",
  "DIRECTDEP",
  "DIRECTDEBIT",
  "HOLD",
  "OTHER",
];

function StepReviewImport() {
  const { translation } = useSelector((state) => state.app);
  const { formData, selectedRowsKeys, setSelectedRowKeys } =
    useImportStatementFormContext();
  const selectAll = useCallback(() => {
    setSelectedRowKeys(formData?.transactions.map((item) => item.id));
  }, [formData, setSelectedRowKeys]);
  const selectAllDebits = useCallback(() => {
    setSelectedRowKeys(
      formData?.transactions
        .filter((item) => item.type === "DEBIT")
        .map((item) => item.id)
    );
  }, [formData, setSelectedRowKeys]);
  const selectAllCredit = useCallback(() => {
    setSelectedRowKeys(
      formData?.transactions
        .filter((item) => item.type === "CREDIT")
        .map((item) => item.id)
    );
  }, [formData, setSelectedRowKeys]);
  const genTableRowClassName = useCallback(
    (record) =>
      record.alreadyMarkedToConciliate
        ? "table-row-gray"
        : ["DEBIT", "PAYMENT", "DIRECTDEBIT"].includes(record.type)
        ? "table-row-red"
        : record.type === "CREDIT"
        ? "table-row-green"
        : "",
    []
  );
  return (
    <ContainerReviewImport>
      <Row type="flex">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <p className="message">
            {translation.statement.messages.reviewMessage}
          </p>
        </Col>
      </Row>
      <Row type="flex">
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Row>
            <label>{translation.statement.form.bankName}</label>
          </Row>
          <Row>
            <strong>{formData?.bankName}</strong>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Row>
            <label>{translation.statement.form.bankAgencyNumber}</label>
          </Row>
          <Row>
            <strong>{formData?.bankAgencyNumber}</strong>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Row>
            <label>{translation.statement.form.bankAccountNumber}</label>
          </Row>
          <Row>
            <strong>{formData?.bankAccountNumber}</strong>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Row>
            <label>{translation.statement.form.period}</label>
          </Row>
          <Row>
            <strong>{`${moment(formData?.startTransactionsDate).format(
              "DD/MM/YYYY"
            )} a ${moment(formData?.endTransactionsDate).format(
              "DD/MM/YYYY"
            )}`}</strong>
          </Row>
        </Col>
      </Row>
      {/* Table Transactions */}
      <Divider>{translation.statement.form.transactions}</Divider>
      <Row type="flex" gutter={8} style={{ marginBottom: 16 }}>
        <Col>
          <ButtonStandard
            buttonType={"cancel"}
            onClick={() => setSelectedRowKeys([])}
          >
            <Icon type="delete" />
            Limpar Seleção
          </ButtonStandard>
        </Col>
        <Col>
          <ButtonStandard buttonType={"secondary"} onClick={selectAll}>
            <Icon type="check" />
            Selecionar todos
          </ButtonStandard>
        </Col>
        <Col>
          <ButtonStandard buttonType={"secondary"} onClick={selectAllDebits}>
            <Icon type="check" />
            Selecionar todos os Débitos
          </ButtonStandard>
        </Col>
        <Col>
          <ButtonStandard buttonType={"secondary"} onClick={selectAllCredit}>
            <Icon type="check" />
            Selecionar todos os Créditos
          </ButtonStandard>
        </Col>
      </Row>
      <Row>
        <Table
          dataSource={formData?.transactions}
          columns={[
            {
              title: translation.statement.table.columns.transactionDate,
              dataIndex: "transactionDate",
              key: "transactionDate",
              sortDirections: ["ascend", "descend"],
              defaultSortOrder: "ascend",
              sorter: (first, second) => {
                return first.transactionDate.localeCompare(
                  second.transactionDate,
                  "pt-BR",
                  {
                    numeric: true,
                    ignorePunctuation: true,
                  }
                );
              },
              render: (text) => moment(text).format("DD/MM/YYYY"),
            },
            {
              title: translation.statement.table.columns.type,
              dataIndex: "type",
              key: "type",
              sorter: (first, second) => {
                if (!first.type) {
                  first.type = "";
                }
                return first.type.localeCompare(second.type, "pt-BR", {
                  numeric: false,
                  ignorePunctuation: true,
                });
              },
              filtered: true,
              filters: TYPES.map((type) => ({
                text: translation.statement.types[type],
                value: type,
              })),
              onFilter: (value, record) => record.type.indexOf(value) === 0,
              render: (text) => translation.statement.types[text],
            },
            {
              title: translation.statement.table.columns.name,
              dataIndex: "name",
              key: "name",
              sorter: (first, second) => {
                let firstName = first.name ?? first.memo;
                const secondName = second.name ?? second.memo;
                if (!firstName) {
                  firstName = "";
                }
                return firstName.localeCompare(secondName, "pt-BR", {
                  numeric: false,
                  ignorePunctuation: true,
                });
              },
              filtered: true,
              onFilter: (value, record) => record.name.includes(value),
              render: (text, record) => record.name ?? record.memo,
            },
            {
              title: translation.statement.table.columns.amount,
              dataIndex: "amount",
              key: "amount",
              render: (text) => numberMask(text, true),
            },
          ]}
          rowKey="id"
          pagination={{}}
          rowSelection={{
            getCheckboxProps: (record) =>
              record.alreadyMarkedToConciliate ? { disabled: true } : {},
            selectedRowKeys: selectedRowsKeys,
            onSelect: (record, selected, selectedRows, nativeEvent) => {
              if (selected) {
                setSelectedRowKeys((old) => [...old, record.id]);
              } else {
                setSelectedRowKeys((old) => old.filter((r) => r !== record.id));
              }
            },
            onSelectAll: (record, selected, selectedRows, nativeEvent) => {
              // Get just the ids
              const keys = selectedRows.map((sr) => sr.id);
              // Get all the selectedAnimalsKeys unless the unselected
              const lastSelectedAnimalsKeys = selectedRowsKeys.filter(
                (sAK) => !keys.includes(sAK)
              );
              if (record) {
                setSelectedRowKeys((old) => [...old, ...keys]);
              } else {
                setSelectedRowKeys(lastSelectedAnimalsKeys);
              }
            },
          }}
          rowClassName={genTableRowClassName}
        />
      </Row>
    </ContainerReviewImport>
  );
}

export default StepReviewImport;
